import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAgFBDZ_o3yLdFxfwz87izkOcoCNc_vyCg",
  authDomain: "zevelon-dashboard.firebaseapp.com",
  projectId: "zevelon-dashboard",
  storageBucket: "zevelon-dashboard.firebasestorage.app",
  messagingSenderId: "309744505785",
  appId: "1:309744505785:web:2716283201085770b11c68"
};

  

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
